import styled from 'styled-components';

const NavigationButtonDiv = styled.div`
  display: flex;
`;

NavigationButtonDiv.displayName = 'NavigationButtonDiv';

export default NavigationButtonDiv;
